import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function navigationItem(theme: Theme): ComponentStyle {
  return {
    componentName: 'navigationItem',
    baseStyle: {
      color: theme.colors.white85,
      textDecoration: 'none',
      cursor: 'pointer',
      position: 'relative',
      background: 'none',
      padding: [theme.space['m'], `${theme.space['2xs']} ${theme.space['xs']}`],
      fontSize: [theme.sizes['3'], theme.sizes['0']],

      '&.active': {
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          zIndex: -401,
          mixBlendMode: 'plus-lighter',
          background: `linear-gradient(
              0deg,
              rgba(67, 49, 233, 0.1) 0%,
              rgba(67, 49, 233, 0.1) 100%
            )`,
          borderRadius: theme.sizes['-3']
        },

        '&:after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          zIndex: -400,
          mixBlendMode: 'soft-light',
          background: `radial-gradient(
              116.48% 116.48% at 50% 2.27%,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.25) 100%
            ),
            rgba(255, 255, 255, 0.3)`,
          borderRadius: theme.sizes['-3']
        }
      },

      '&:hover': {
        color: theme.colors.text,
        '&:before': {
          background: 'none'
        },
        '&:after': {
          content: '""',
          position: 'absolute',
          borderRadius: theme.sizes['-3'],
          background: theme.colors.white25,
          mixBlendMode: 'overlay',
          inset: 0,
          zIndex: -400
        }
      }
    },
    variants: {
      primary: {
        '&:hover': {}
      },
      secondary: {
        paddingLeft: theme.space['m']
      },
      home: {
        fontWeight: 600,
        fontSize: [theme.sizes['3'], theme.sizes['2']],
        padding: [
          `${theme.space['m']} ${theme.space['3xs']}`,
          `${theme.space['2xs']} ${theme.space['3xs']}`
        ]
      },
      glossary: {
        color: theme.colors.white85,
        fontSize: [theme.sizes['3'], theme.sizes['2']],
        padding: [
          `${theme.space['m']} ${theme.space['3xs']}`,
          `${theme.space['2xs']} ${theme.space['3xs']}`
        ]
      }
    },
    defaultProps: {
      variant: 'primary'
    }
  };
}
